import { CommonModule } from '@angular/common';
import { AfterContentChecked, ChangeDetectorRef, Component, Inject, Injector, Input, Renderer2, TemplateRef, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LoadingService } from '../../helper';
import { PopupData } from '../../interfaces';
import { BasePopUpComponent } from '../base-popup-component/base-popup.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { IconSvgComponent } from '../icon/svg-icon.component';
import { IconsConstants } from '../../common';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, SpinnerComponent, IconSvgComponent],
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent<T, Data> extends BasePopUpComponent<T> implements OnInit, AfterContentChecked {
  @Input() template: TemplateRef<any>;
  IconConstants = IconsConstants;
  private clickEscListener: () => void;

  constructor(
    public dialogRef: MatDialogRef<PopupComponent<T, Data>>,
    @Inject(MAT_DIALOG_DATA) public data: PopupData<Data>,
    injector: Injector,
    // loading service to get the popup loading observable and use it in the template
    public loadingService : LoadingService,
    private renderer: Renderer2,
  ) {
    super([], injector);
  }

  ngOnInit(): void {
    this.addingEventListeners();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.clickEscListener) {
      this.clickEscListener();
    }
  }

  ngAfterContentChecked(): void {
    // to run change detection
    this.injector.get(ChangeDetectorRef).detectChanges()
  }

  private addingEventListeners(): void {
    setTimeout(() => {
      this.clickEscListener = this.renderer.listen(document, 'keydown', (event: KeyboardEvent) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
          this.onClose(this.dialogRef);
        }
      });
    }, 0);
  }
}
